// store/entities/player-settings-slice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  music_enabled: true,
  sound_enabled: false,
};

const playerSettingsSlice = createSlice({
  name: "playerSettings",
  initialState,
  reducers: {
    // postavi kompletno stanje (npr. posle logina)
    loginSetPlayerSettings(state, action) {
      
      const { sound_enabled } = action.payload || {};
      state.sound_enabled = Boolean(sound_enabled);
    },

    // lokalni toggle-i (bez HTTP-a)
    toggleSound(state) {
      state.sound_enabled = !state.sound_enabled;
    },
    toggleMusic(state) {
      state.music_enabled = !state.music_enabled;
    },

    // opcioni setter ako treba ručno da postaviš obe vrednosti odjednom
    setPlayerSettingsLocal(state, action) {
      const { music_enabled, sound_enabled } = action.payload || {};
      if (typeof music_enabled === "boolean") state.music_enabled = music_enabled;
      if (typeof sound_enabled === "boolean") state.sound_enabled = sound_enabled;
    },

    // reset (npr. na logout)
    resetPlayerSettings() {
      return initialState;
    },
  },
});

export const {
  loginSetPlayerSettings,
  toggleSound,
  toggleMusic,
  setPlayerSettingsLocal,
  resetPlayerSettings,
} = playerSettingsSlice.actions;

export default playerSettingsSlice.reducer;
